import { frontendURL } from '../../../../helper/URLHelper';
import store from 'dashboard/store';
import { REDIS_FEATURE_FLAGS } from 'dashboard/featureFlags';

// Direct-navigation guard for the per-team overrides step. The wizard already
// hides the step when the flag is off, but the route is reachable by URL — this
// keeps it consistent (and the backend re-gates anyway). Redirects back to the
// team edit page when `team_setting_overrides` is disabled for the account.
const guardOverridesRoute = (to, from, next) => {
  const { accountId, teamId } = to.params;
  const enabled = store.getters['accounts/isFeatureEnabledonAccount'](
    Number(accountId),
    REDIS_FEATURE_FLAGS.TEAM_SETTING_OVERRIDES
  );
  if (enabled) {
    next();
  } else {
    next({ name: 'settings_teams_edit', params: { accountId, teamId } });
  }
};

const TeamsIndex = () => import('./Index.vue');
const CreateStepWrap = () => import('./Create/Index.vue');
const EditStepWrap = () => import('./Edit/Index.vue');
const CreateTeam = () => import('./Create/CreateTeam.vue');
const EditTeam = () => import('./Edit/EditTeam.vue');
const EditAvailability = () => import('./Edit/EditAvailability.vue');
const EditOverrides = () => import('./Edit/EditOverrides.vue');
const AddAgents = () => import('./Create/AddAgents.vue');
const EditAgents = () => import('./Edit/EditAgents.vue');
const FinishSetup = () => import('./FinishSetup.vue');
const SettingsContent = () => import('../Wrapper.vue');
const SettingsWrapper = () => import('../SettingsWrapper.vue');

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/teams'),
      component: SettingsWrapper,
      children: [
        {
          path: '',
          redirect: 'list',
        },
        {
          path: 'list',
          name: 'settings_teams_list',
          component: TeamsIndex,
          meta: {
            permissions: ['administrator'],
          },
        },
      ],
    },
    {
      path: frontendURL('accounts/:accountId/settings/teams'),
      component: SettingsContent,
      props: () => {
        return {
          headerTitle: 'TEAMS_SETTINGS.HEADER',
          headerButtonText: 'TEAMS_SETTINGS.NEW_TEAM',
          icon: 'people-team',
          newButtonRoutes: ['settings_teams_new'],
          showBackButton: true,
        };
      },
      children: [
        {
          path: 'new',
          component: CreateStepWrap,
          children: [
            {
              path: '',
              name: 'settings_teams_new',
              component: CreateTeam,
              meta: {
                permissions: ['administrator'],
              },
            },
            {
              path: ':teamId/finish',
              name: 'settings_teams_finish',
              component: FinishSetup,
              meta: {
                permissions: ['administrator'],
              },
            },
            {
              path: ':teamId/agents',
              name: 'settings_teams_add_agents',
              meta: {
                permissions: ['administrator'],
              },
              component: AddAgents,
            },
          ],
        },
        {
          path: ':teamId/edit',
          component: EditStepWrap,
          children: [
            {
              path: '',
              name: 'settings_teams_edit',
              component: EditTeam,
              meta: {
                permissions: ['administrator'],
              },
            },
            {
              path: 'working_hours',
              name: 'settings_teams_edit_working_hours',
              component: EditAvailability,
              meta: {
                permissions: ['administrator'],
              },
            },
            {
              path: 'overrides',
              name: 'settings_teams_edit_overrides',
              component: EditOverrides,
              beforeEnter: guardOverridesRoute,
              meta: {
                permissions: ['administrator'],
              },
            },
            {
              path: 'agents',
              name: 'settings_teams_edit_members',
              component: EditAgents,
              meta: {
                permissions: ['administrator'],
              },
            },
            {
              path: 'finish',
              name: 'settings_teams_edit_finish',
              meta: {
                permissions: ['administrator'],
              },
              component: FinishSetup,
            },
          ],
        },
      ],
    },
  ],
};
